import type { Ref } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Routes } from '@/utils/navigation/routes'
import { rememberOnboardingDoor } from '@/utils/onboardingEntry'
import { Typography } from '@/UI-KIT/Typography/Typography'

import styles from './ClosingCta.module.scss'

type ClosingCtaProps = {
  onBookDemo: () => void
  /** The block itself, for the phone's pinned ask (LandingStickyCta): on screen, the bar goes down. */
  rootRef?: Ref<HTMLElement>
}

export const ClosingCta = ({ onBookDemo, rootRef }: ClosingCtaProps) => {
  const { t } = useTranslation()

  return (
    <section ref={rootRef} id="cta" className={styles.root}>
      <div className={styles.band}>
        <div className={styles.kicker}>{t('landing.closing.kicker')}</div>
        <Typography variant="h2" color="heading" className={styles.title}>
          {t('landing.closing.title')}
        </Typography>
        <Typography variant="t2" color="ink2" className={styles.text}>
          {t('landing.closing.text')}
        </Typography>
        <div className={styles.ctas}>
          <Link
        className={`${styles.button} ${styles.buttonPrimary}`}
        to={Routes.onboard}
        onClick={() => rememberOnboardingDoor('closing')}
      >
            {t('landing.cta.primary')}&nbsp;&nbsp;→
          </Link>
          <button
            type="button"
            className={`${styles.button} ${styles.buttonSecondary}`}
            onClick={onBookDemo}
          >
            {t('landing.nav.bookDemo')}
          </button>
        </div>
      </div>
    </section>
  )
}
